import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, Phone, LogIn } from 'lucide-react';
import { ViewToggle } from './ViewToggle';
export function PortalNavbar() {
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-602">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-603">
        <div className="flex justify-between items-center h-16 md:h-20" data-id="element-604">
          {/* Logo */}
          <Link to="/" className="flex items-center group" aria-label="Compass Recovery Group home" data-id="element-605">
            <img src="https://cdn.magicpatterns.com/uploads/miiyVjkag3qKFYCybFaUjL/pasted-image.jpg" alt="Compass Recovery Group, LLC" className="h-10 md:h-12 w-auto object-contain" data-id="element-606" />
          </Link>

          {/* Nav Links */}
          <nav className="flex items-center gap-3 md:gap-6" data-id="element-607">
            <a href="#faq" className="hidden md:flex items-center gap-2 text-sm font-medium text-brand-dark hover:text-brand-navy transition-colors" data-id="element-608">
              <HelpCircle size={18} className="text-brand-muted" data-id="element-609" />
              Help & FAQ
            </a>
            <a href="#contact" className="hidden md:flex items-center gap-2 text-sm font-medium text-brand-dark hover:text-brand-navy transition-colors" data-id="element-610">
              <Phone size={18} className="text-brand-muted" data-id="element-611" />
              Contact
            </a>
            <div className="w-px h-6 bg-gray-200 hidden md:block" data-id="element-612"></div>
            <button className="flex items-center gap-2 bg-brand-navy hover:bg-brand-navy/90 text-white px-4 py-2 rounded font-semibold text-sm transition-colors shadow-sm" data-id="element-613">
              <LogIn size={18} data-id="element-614" />
              <span className="hidden sm:inline" data-id="element-615">Log In</span>
            </button>
            <ViewToggle activeView="consumer" data-id="element-616" />
          </nav>
        </div>
      </div>
    </header>;
}